export const MOBILE_BREAKPOINT = 500;
export const TABLET_BREAKPOINT = 650;
export const BIG_BREAKPOINT = 800;
export const BIGGER_BREAKPOINT = 1280;
export const LARGE_BREAKPOINT = 1700;

export const MAX_WIDTH = 1920;
export const DESKTOP_CONTENT_WIDTH = 900;
